export const DEFAULT_REGION_ID = 4593; // Московская область
export const DEFAULT_REGION_NAME = 'Московская область';
